"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createSliceReducer: true,
  initMergeSliceReducer: true,
  mergeSliceReducer: true,
  deprecated: true,
  createAction: true,
  createAndMergeSliceReducer: true,
  createAndMergeModuleReducer: true,
  initMergeSaga: true,
  mergeSaga: true,
  storeHelper: true
};
Object.defineProperty(exports, "createSliceReducer", {
  enumerable: true,
  get: function get() {
    return _createSliceReducer.createSliceReducer;
  }
});
Object.defineProperty(exports, "initMergeSliceReducer", {
  enumerable: true,
  get: function get() {
    return _mergeSliceReducer.initMergeSliceReducer;
  }
});
Object.defineProperty(exports, "mergeSliceReducer", {
  enumerable: true,
  get: function get() {
    return _mergeSliceReducer.mergeSliceReducer;
  }
});
Object.defineProperty(exports, "deprecated", {
  enumerable: true,
  get: function get() {
    return _deprecated.deprecated;
  }
});
Object.defineProperty(exports, "createAction", {
  enumerable: true,
  get: function get() {
    return _reduxActions.createAction;
  }
});
Object.defineProperty(exports, "createAndMergeSliceReducer", {
  enumerable: true,
  get: function get() {
    return _createAndMergeSliceReducer.createAndMergeSliceReducer;
  }
});
Object.defineProperty(exports, "createAndMergeModuleReducer", {
  enumerable: true,
  get: function get() {
    return _createAndMergeModuleReducer.createAndMergeModuleReducer;
  }
});
Object.defineProperty(exports, "initMergeSaga", {
  enumerable: true,
  get: function get() {
    return _mergeSaga.initMergeSaga;
  }
});
Object.defineProperty(exports, "mergeSaga", {
  enumerable: true,
  get: function get() {
    return _mergeSaga.mergeSaga;
  }
});
Object.defineProperty(exports, "storeHelper", {
  enumerable: true,
  get: function get() {
    return _storeHelper.storeHelper;
  }
});

var _createSliceReducer = require("./deprecated/create-slice-reducer");

var _mergeSliceReducer = require("./deprecated/merge-slice-reducer");

var _deprecated = require("./deprecated.util");

var _reduxActions = require("redux-actions");

var _createAndMergeSliceReducer = require("./create-and-merge-slice-reducer");

var _createAndMergeModuleReducer = require("./create-and-merge-module-reducer");

var _mergeSaga = require("./merge-saga");

var _storeHelper = require("./store-helper");

var _reducers = require("./reducers.types");

Object.keys(_reducers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _reducers[key];
    }
  });
});